// extracted by mini-css-extract-plugin
export default {"keyboardShortcut":"styles_keyboardShortcut__TphEB","dark":"styles_dark__Us9wx"};